<template>
  <quick-filter-wrapper class="wrapper">
    <species-filter />
  </quick-filter-wrapper>
</template>
<!-- eslint-disable vue/block-lang -->
<script setup>
///// imports /////
import quickFilterWrapper from '@/components/activity-filtering/quick-filter-wrapper.vue'
import speciesFilter from '@/fish/components/filtering/species-filter'
</script>
<style lang="scss" scoped>
@use '@/styles/system/_breakpoints.scss';

.wrapper {
  width: var(--card-width);
  padding-top: var(--ys-spacing-250);
  padding-bottom: var(--ys-spacing-250);
  @include breakpoints.mobile {
    margin-left: -31px;
  }
}
</style>
